var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14272 2.14287H3.57129V3.57145H16.4284V2.14287H12.857L11.4284 1.42859H9.99986H8.57129L7.14272 2.14287ZM4.28557 4.28573H15.7141V17.5714C15.7141 18.1237 15.2664 18.5714 14.7141 18.5714H5.28558C4.73329 18.5714 4.28557 18.1237 4.28557 17.5714V4.28573ZM5.71415 17.1429V5.7143H14.2856V17.1429H5.71415Z",
    fill: "#2D72FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTrash);
export default __webpack_public_path__ + "static/media/icn_trash.9735bf3389b6d4ef65ff55b4fa596513.svg";
export { ForwardRef as ReactComponent };